// 404 fallback for unknown routes.

import { Link } from "react-router-dom";

export function NotFoundPage(): JSX.Element {
  return (
    <section>
      <h1>Not found</h1>
      <p>
        <Link to="/dashboard">Return to dashboard</Link>
      </p>
    </section>
  );
}
